<template>
	<div :class="{
		'px-8 py-8 main': true,
		'main_desktop': $vuetify.breakpoint.mdAndUp
	}">

		<h1 :class="{
			'heading text-center': true,
			'text-h2 ': $vuetify.breakpoint.mdAndUp,
			'text-h3 ': $vuetify.breakpoint.smAndDown,
		}">
			Shipping Calculator
		</h1>

		<p :class="{
			'subheading': true,
			'text-h5 ': $vuetify.breakpoint.mdAndUp,
			'text-subtitle-2 ': $vuetify.breakpoint.smAndDown,
		}">
			Estimate your shipping cost
		</p>


		<!-- <div> -->
		<!-- 	<v-btn color="primary" @click="addNewItem">Add another package/pallet</v-btn> -->
		<!-- </div> -->


		<div :class="{
			'items': true,
			'items_desktop': $vuetify.breakpoint.mdAndUp,
			'items_mobile': $vuetify.breakpoint.smAndDown,
		}">
			<div class="flex-grow-1" style="max-width:100%">

				<v-btn-toggle
					style="align-self: stretch;width:100%;"
					block
					variant="flat"
					color="brown"
					mandatory
					flat
					v-model="shipmentMethod"
				>
					<v-btn variant="flat" style="max-width:50%;" :class="{
						'flex-grow-1': true,
						'text-subtitle-1 text-break ': $vuetify.breakpoint.smAndDown,
					}" value="ocean">
						<span :class="{'text-break text-caption': $vuetify.breakpoint.smAndDown}">Ocean Shipment</span>
					</v-btn>
					<v-btn variant="flat" style="max-width:50%;" :class="{
						'flex-grow-1': true,
						'text-subtitle-1 text-break ': $vuetify.breakpoint.smAndDown,
						}" value="air">
							<span :class="{'text-break text-caption': $vuetify.breakpoint.smAndDown}">Air Shipment</span>
					</v-btn>


				</v-btn-toggle>
				<template v-for="(item, ind) in items">
					<Item :item="item" :key="ind" @delete="removeItem(ind)" 
					:isLast="ind === items.length - 1" :isFirst="ind === 0"
					@addNew="addNewItem"
					:shipmentMethod="shipmentMethod"

					:customBrokerFee="customBrokerFee" 
					:portFee="portFee" 
					:insurance="insurance" 
					>
					</Item>
				</template>

				<div v-if="items.length === 0" class="my-4">
					<v-btn
						@click="addNewItem"
						small
						outlined
						color="brown"
					>
						<v-icon dark>
							mdi-plus
						</v-icon>
						Add Package
					</v-btn>
				</div>

				<div class="total">
					<span class="title">Total Estimate: </span>
					<span class="value ">{{ formatCost(totalFees) }}</span>

				</div>

			</div>

			<!-- 
			<div :class="{'separator': $vuetify.breakpoint.mdAndUp}" />

			<div :class="{
				'summary': true,
				'summary_desktop': $vuetify.breakpoint.mdAndUp,
			}">
				<div class="text-h4 heading ">
					Summary
				</div>
				<v-divider />
				<div class="total">
					<span class="value text-h4 ">${{ totalFees.toFixed(2) }}</span>
				</div>
				<span class="subtitle ">

					<v-icon color="blue-grey lighten-3">mdi-information-outline</v-icon>
					Import duty is paid, generally at a rate of 22% on importation of most goods, including on the freight charge.
					Please refer to 
					<a href="https://www.gov.ky/cbc/info/latest-guides">the Cayman Islands Customs website</a> 
					for the latest list of tariff rates.
				</span>
			</div>
			 -->
		</div>
	</div>
</template>

<style>
.main {
	display: flex;
	gap: 0.5rem;
	flex-direction: column;
	align-items: center;
	margin: 0.5rem auto;
	width: 100%;

}

.main_desktop {
	max-width: 60%;
}

.heading {
	color: #451813; 
}

.subheading {
	color: #e7c076;
}

.separator {
	border-left: 1px solid #f5cca2;
}
.items {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	width: 100%;
}
.items_desktop {
	display: grid;
	grid-template-columns: 1fr;
}

.summary {
	flex-grow: 1;
	justify-content: center;

	display: flex;
	flex-direction: column;

	gap: 0.75rem;

	border-radius: 0.5rem;

	/* background-color: #fbd8b660; */
	/* background-color: #f3e0bc; */
	background-color: #79554840;

	border-radius: 0.5rem;

	padding: 1rem 3rem;
}

.summary_desktop {
	height: 100%;
	max-height: 600px;
}

.total {
	display: flex;
	flex-direction: column;
}

.total .title {
	font-size: 1.25rem;
	color: #451813; 
}
.total .value {
	/* color: #78938a; */
	font-weight: bold;
	color: #e7c076;
}

.summary .total .value {
	/* color: #74a892; */
}

.summary .subtitle {
	color: #451813;
}
</style>

<script>

import Item from './Item.vue'
import { calcFreightCarge, calcTotalGovFees, calcPortFee, calcInsurance, calcVolume, calcBrokerFee,
	calcMiaWarehouseFee, calcTotalFees, formatCost} from './utils'

export default {
  name: 'PriceCalculator',

  components: {
		Item
  },

  props: {
  },

  data: () => ({
		shipmentMethod: 'ocean',
		air_items: [
			{
				weight: 0,

				type: 'package',
				// type: 'pallet',

				count: 1,

				invoiceTotal: 0,
			},
		],
		ocean_items: [
			{
				width: 0,
				height: 0,
				depth: 0,

				type: 'package',
				// type: 'pallet',

				count: 1,

				invoiceTotal: 0,
			},
		],
  }),

  mounted: function () {
  },

  computed: {
		items: function() {
			if (this.shipmentMethod === 'ocean') return this.ocean_items;
			else return this.air_items;
		},
		insurance: function() {
			return calcInsurance(this.shipmentMethod, this.items)
		},
		portFee: function() {
			return calcPortFee(this.shipmentMethod, this.items)
		},
		warehouseFee: function() {
			return calcMiaWarehouseFee(this.shipmentMethod, this.items)
		},
		customBrokerFee: function() {
			return calcBrokerFee(this.shipmentMethod, this.items)
		},
		govFees: function() {
			return calcTotalGovFees(this.shipmentMethod, this.items)
		},

		totalFees: function() {
			return calcTotalFees(this.shipmentMethod, this.items)
		},
		
  },

  methods: {
		formatCost(num) { return formatCost(num) },

		addNewItem() {
			this.items.push({
				width: 0,
				height: 0,
				depth: 0,

				weight: 0,

				type: 'package',
				// type: 'pallet',

				count: 1,

				invoiceTotal: 0,
			});
		},

		removeItem(ind) {
			this.items.splice(ind, 1)
		},
  },
};
</script>
